import { Button, Stack, Typography } from '@mui/material'
import React from 'react';
import { useState } from 'react';
import { useQuery } from 'react-query';
import CustomDropDown from '../../../components/CustomDropDown';
import FillLabelTxtField from '../../../components/FillLabelTxtField';
import { customAlert } from '../../../components/notify';
import { useAuthContext } from '../../../context/AuthContext';
import QueryKey from '../../../QueryKey';
import { getFuelCouponData } from '../../../services/req_service';
import { genFuelCoupon } from '../../../services/pdf-service';
import { datePickerformat } from '../../../utils/format';


const productArr = [
    { value: "DIESEL", label: "Diesel" },
    { value: "CNG", label: "CNG" },
    { value: "EV CHARGE", label: "EV Charge" },
    { value: "HYDROGEN", label: "Hydrogen" },
];

const ISSUED_BY = "S Kannan";

// Inline fuel-coupon form shown inside the Add Truck Operator Payment modal
// when Mode of Payment is Fuel. All fields are prefilled from the truck
// operator request being paid; only Product is editable.
function FuelCouponSection({ trkOpReqId, amount, issuedDate, onGenerated }) {
    const { setLoadingScreen } = useAuthContext();
    const [product, setProduct] = useState(productArr[0].value);

    const { data: cpnData } = useQuery([QueryKey.fuelCouponData, trkOpReqId],
        () => getFuelCouponData(trkOpReqId), { enabled: !!trkOpReqId });

    const cpnDate = datePickerformat(issuedDate || new Date());
    // <stationCode>-<serial><DDMMYY> e.g. MUM-1000060826; station code =
    // the request's start-location code (first 3 letters after "TR-")
    const stationCode = (String(trkOpReqId || '').split('-')[1] || '').slice(0, 3).toUpperCase() || 'CVP';
    const [yyyy, mm, dd] = (cpnDate || '').split('-');
    const couponNoPreview = `${stationCode}-${cpnData?.nextCouponSerial || 1000}${dd || ''}${mm || ''}${(yyyy || '').slice(-2)}`;

    const transporterName = cpnData?.comName ||
        `${cpnData?.trkOpFName || ''} ${cpnData?.trkOpLName || ''}`.trim();

    let txtFieldProps = { fontSize: 14, height: 38, width: 520 };

    function handleProductChange(e) {
        setProduct(e.target.value || productArr[0].value);
    }

    async function handleGenerate() {
        setLoadingScreen(true);
        try {
            const res = await genFuelCoupon({
                trkOpReqId,
                product,
                couponAmt: amount,
                issuedDate: cpnDate
            });
            window.open(res.fileUrl, "_blank");
            if (onGenerated)
                onGenerated({ couponNo: res.couponNo, couponFile: res.fileUrl });
        } catch (err) {
            // console.log(err);
            customAlert(err);
        }
        setLoadingScreen(false);
    }

    return (
        <Stack gap={2} sx={{ mt: 1, pt: 2, borderTop: 1, borderColor: 'rgba(223, 218, 248, 0.9)' }}>
            <Typography sx={{ fontWeight: "bold", fontSize: 15, color: "rgba(0, 0, 0, 0.6)" }}>Fuel Coupon</Typography>
            <Stack direction={'row'} alignItems={"center"} gap={3}>
                <FillLabelTxtField key={`vehNo-${cpnData?.trkRegNo || ''}`} name="cpnVehicleNo" title={"Vehicle No"} defaultValue={cpnData?.trkRegNo || ''} readOnly={true} {...txtFieldProps} width={250} />
                <FillLabelTxtField key={`trName-${transporterName}`} name="cpnTransporterName" title={"Transporter Name"} defaultValue={transporterName} readOnly={true} {...txtFieldProps} width={250} />
            </Stack>
            <Stack direction={'row'} alignItems={"center"} gap={3}>
                <FillLabelTxtField key={`trCon-${cpnData?.trkOpContact || ''}`} name="cpnTransporterContact" title={"Transporter Contact"} defaultValue={cpnData?.trkOpContact || ''} readOnly={true} {...txtFieldProps} width={250} />
                <FillLabelTxtField key={`drName-${cpnData?.drivName || ''}`} name="cpnDriverName" title={"Driver Name"} defaultValue={cpnData?.drivName || ''} readOnly={true} {...txtFieldProps} width={250} />
            </Stack>
            <Stack direction={'row'} alignItems={"center"} gap={3}>
                <FillLabelTxtField key={`drCon-${cpnData?.drivMobile || ''}`} name="cpnDriverContact" title={"Driver Contact"} defaultValue={cpnData?.drivMobile || ''} readOnly={true} {...txtFieldProps} width={250} />
                <FillLabelTxtField key={`date-${cpnDate}`} type={"date"} name="cpnDate" title={"Date"} defaultValue={cpnDate} readOnly={true} {...txtFieldProps} width={250} />
            </Stack>
            <Stack direction={'row'} alignItems={"center"} gap={3}>
                <FillLabelTxtField key={`shipId-${trkOpReqId}`} name="cpnShipmtId" title={"Shipment ID"} defaultValue={trkOpReqId || ''} readOnly={true} {...txtFieldProps} width={250} />
                <FillLabelTxtField key={`cpnNo-${couponNoPreview}`} name="cpnCouponNo" title={"Coupon No"} defaultValue={couponNoPreview} readOnly={true} {...txtFieldProps} width={250} />
            </Stack>
            <Stack direction={'row'} alignItems={"center"} gap={3}>
                <CustomDropDown handleDDChange={handleProductChange} defaultValue={productArr[0].value} title={"Product"} name={"cpnProduct"} ddArr={productArr} {...txtFieldProps} width={250} />
                <FillLabelTxtField key={`amt-${amount || ''}`} type="number" name="cpnCouponAmt" title={"Coupon Amount"} defaultValue={amount || ''} readOnly={true} {...txtFieldProps} width={250} />
            </Stack>
            <Stack direction={'row'} alignItems={"center"} gap={3}>
                <FillLabelTxtField name="cpnIssuedBy" title={"Issued By"} defaultValue={ISSUED_BY} readOnly={true} {...txtFieldProps} width={250} />
                <Stack sx={{ width: 250, alignItems: "flex-end", justifyContent: "flex-end", pt: 3 }}>
                    <Button type="button" variant="contained" sx={{ height: 38, width: 150 }} onClick={handleGenerate}>Generate</Button>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default FuelCouponSection;
